var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 7.33341C12.833 5.30758 11.1922 3.66675 9.16634 3.66675C7.14051 3.66675 5.49967 5.30758 5.49967 7.33341C5.49967 9.35925 7.14051 11.0001 9.16634 11.0001C11.1922 11.0001 12.833 9.35925 12.833 7.33341ZM1.83301 16.5001V17.4167C1.83301 17.9209 2.24551 18.3334 2.74967 18.3334H15.583C16.0872 18.3334 16.4997 17.9209 16.4997 17.4167V16.5001C16.4997 14.0617 11.6138 12.8334 9.16634 12.8334C6.71884 12.8334 1.83301 14.0617 1.83301 16.5001ZM16.4997 9.16675H20.1663C20.6705 9.16675 21.083 9.57925 21.083 10.0834C21.083 10.5876 20.6705 11.0001 20.1663 11.0001H16.4997C15.9955 11.0001 15.583 10.5876 15.583 10.0834C15.583 9.57925 15.9955 9.16675 16.4997 9.16675Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonRemoveIcon);
export default __webpack_public_path__ + "static/media/PersonRemoveIcon.ddbe02db5a5b9e803a630aeb03393e5c.svg";
export { ForwardRef as ReactComponent };